import { render, staticRenderFns } from "./AddValidation.vue?vue&type=template&id=57265cd6&scoped=true&"
import script from "./AddValidation.vue?vue&type=script&lang=js&"
export * from "./AddValidation.vue?vue&type=script&lang=js&"
import style0 from "./AddValidation.vue?vue&type=style&index=0&id=57265cd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57265cd6",
  null
  
)

export default component.exports